

// const BASE_URL = "https://staging.pteshstudios.com";

import { useState, useEffect, useRef } from "react";
import "./Management.css";
import "./homepageEditor.css"; // adjust path as needed
import Avatar  from '../../Images/leader_1.png';
import Avatar2 from '../../Images/leader_2.png';
import Avatar3 from '../../Images/leader_3.png';
import Avatar4 from '../../Images/leader_4.png';
import Avatar1 from '../../Images/team.png'
import Aboutbg from '../../Images/leadbg.jpeg'

const API_BASE      = "http://localhost:5000/api/management";
const UPLOAD_URL    = "http://localhost:5000/api/upload";
const SERVER_ORIGIN = "http://localhost:5000";

/* Local fallback images mapped by index */
const LOCAL_IMGS = [Avatar, Avatar2, Avatar3, Avatar4];

const resolveUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${SERVER_ORIGIN}${url}`;
};

const DEFAULT_MEMBERS = [
  { name: "Dr. (Engr.) CHIMAOBI JONATHAN IBENECHE", role: "Chairman, Board of Directors",        img: "", linkedin: "#", featured: true  },
  { name: "Engr. SAMUEL ADEYEMI OKAFOR",            role: "Managing Director / CEO",             img: "", linkedin: "#", featured: false },
  { name: "Chief EMEKA NWACHUKWU",                  role: "Executive Director, Operations",      img: "", linkedin: "#", featured: false },
  { name: "Mrs. ADAEZE OBIORA",                     role: "Executive Director, Finance & Admin", img: "", linkedin: "#", featured: false },
];

/* =========================================================
   IMAGE UPLOAD FIELD
========================================================= */
function ImageUploadField({ label, currentUrl, onUploaded }) {
  const [preview,   setPreview]   = useState(resolveUrl(currentUrl) || null);
  const [uploading, setUploading] = useState(false);
  const [error,     setError]     = useState(null);
  const inputRef = useRef();

  useEffect(() => { setPreview(resolveUrl(currentUrl) || null); }, [currentUrl]);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setPreview(URL.createObjectURL(file));
    setError(null);
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("image", file);
      const res  = await fetch(UPLOAD_URL, { method: "POST", body: formData });
      const json = await res.json();
      if (!json.success) throw new Error(json.message || "Upload failed");
      onUploaded(json.url);
      setPreview(resolveUrl(json.url));
    } catch (err) {
      setError("Upload failed. Try again.");
    } finally { setUploading(false); }
  };

  const handleRemove = () => {
    setPreview(null);
    onUploaded("");
    if (inputRef.current) inputRef.current.value = "";
  };

  return (
    <div className="editor-img-field">
      <label>{label}</label>
      {preview ? (
        <div className="editor-img-preview-wrap">
          <img src={preview} alt="preview" className="editor-img-preview" />
          {uploading && <div className="editor-img-uploading"><div className="editor-loading__spinner editor-loading__spinner--sm" /><span>Uploading...</span></div>}
          {!uploading && (
            <div className="editor-img-actions">
              <button type="button" className="editor-img-btn editor-img-btn--change" onClick={() => inputRef.current?.click()}>Change</button>
              <button type="button" className="editor-img-btn editor-img-btn--remove" onClick={handleRemove}>Remove</button>
            </div>
          )}
        </div>
      ) : (
        <button type="button" className="editor-img-dropzone" onClick={() => inputRef.current?.click()} disabled={uploading}>
          {uploading
            ? <><div className="editor-loading__spinner editor-loading__spinner--sm" /><span>Uploading...</span></>
            : <><span className="editor-img-dropzone__icon">🖼️</span><span>Click to upload photo</span><span className="editor-img-dropzone__hint">JPG, PNG, WEBP — max 10MB</span></>
          }
        </button>
      )}
      {error && <p className="editor-img-error">{error}</p>}
      <input ref={inputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleFile} />
    </div>
  );
}

/* =========================================================
   EDIT MODAL
========================================================= */
function ManagementEditModal({ data, onSave, onClose, saving }) {
  const [draft, setDraft] = useState(() => JSON.parse(JSON.stringify(data)));

  const setMemberField = (i, field, val) =>
    setDraft(d => {
      const members = [...d.members];
      members[i] = { ...members[i], [field]: val };
      return { ...d, members };
    });

  const addMember = () =>
    setDraft(d => ({
      ...d,
      members: [...d.members, { name: "New Member", role: "Role", img: "", linkedin: "#", featured: false }],
    }));

  const removeMember = (i) =>
    setDraft(d => ({ ...d, members: d.members.filter((_, idx) => idx !== i) }));

  return (
    <div className="editor-overlay" onClick={onClose}>
      <div className="editor-modal" onClick={e => e.stopPropagation()}>

        <div className="editor-modal__header">
          <h2>Edit Management Team</h2>
          <button className="editor-modal__close" onClick={onClose}>✕</button>
        </div>

        <div className="editor-modal__body">

          <p className="editor-section__title">Team Members</p>

          {draft.members.map((member, i) => (
            <div key={i} className="editor-group">

              {/* Group header */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <p className="editor-group__label">{member.name || `Member ${i + 1}`}</p>
                {draft.members.length > 1 && (
                  <button className="editor-value-row__remove" onClick={() => removeMember(i)} title="Remove member">✕</button>
                )}
              </div>

              {/* Photo */}
              <ImageUploadField
                label="Photo"
                currentUrl={member.img}
                onUploaded={url => setMemberField(i, "img", url)}
              />

              {/* Name */}
              <label>Full Name</label>
              <input
                value={member.name}
                onChange={e => setMemberField(i, "name", e.target.value)}
              />

              {/* Role */}
              <label>Role / Title</label>
              <input
                value={member.role}
                onChange={e => setMemberField(i, "role", e.target.value)}
              />

              {/* LinkedIn */}
              <label>LinkedIn URL</label>
              <input
                value={member.linkedin}
                onChange={e => setMemberField(i, "linkedin", e.target.value)}
                placeholder="https://linkedin.com/in/..."
              />

              {/* Featured toggle */}
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "6px" }}>
                <input
                  type="checkbox"
                  id={`featured-${i}`}
                  checked={!!member.featured}
                  onChange={e => setMemberField(i, "featured", e.target.checked)}
                  style={{ width: "16px", height: "16px", cursor: "pointer" }}
                />
                <label htmlFor={`featured-${i}`} style={{ margin: 0, cursor: "pointer" }}>
                  Featured (shown solo at the top)
                </label>
              </div>

            </div>
          ))}

          <button className="editor-add-btn" onClick={addMember}>+ Add Member</button>

        </div>

        <div className="editor-modal__footer">
          <button className="btn btn--ghost" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="btn btn--orange" onClick={() => onSave(draft)} disabled={saving}>
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </div>

      </div>
    </div>
  );
}

/* =========================================================
   LINKEDIN ICON
========================================================= */
// function LinkedInIcon() {
//   return (
//     <svg className="linkedin-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-label="LinkedIn">
//       <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.07 2.07 0 1 1 0-4.14 2.07 2.07 0 0 1 0 4.14zm1.78 13.02H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45C23.2 24 24 23.23 24 22.27V1.73C24 .77 23.2 0 22.22 0z" />
//     </svg>
//   );
// }

/* =========================================================
   MEMBER CARD
========================================================= */
function MemberCard({ member, fallbackImg }) {
  const imgSrc = resolveUrl(member.img) || fallbackImg;
  return (
    <div className={`member-card${member.featured ? " member-card--featured" : ""}`}>
      <div className="member-card__img-wrap">
        <img src={imgSrc} alt={member.name} className="member-card__img" />
      </div>
      <div className="member-card__body">
        <h3 className="member-card__name">{member.name}</h3>
        <p className="member-card__role">{member.role}</p>
        {/* <a href={member.linkedin} className="member-card__linkedin" aria-label="LinkedIn Profile">
          <LinkedInIcon />
        </a> */}
      </div>
    </div>
  );
}

/* =========================================================
   MAIN EXPORT
========================================================= */
export default function AdminLeadership() {
  const [pageData,  setPageData]  = useState({ members: DEFAULT_MEMBERS });
  const [modalOpen, setModalOpen] = useState(false);
  const [saving,    setSaving]    = useState(false);
  const [saveMsg,   setSaveMsg]   = useState(null);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      const res  = await fetch(API_BASE);
      const json = await res.json();
      if (json.success) setPageData(json.data);
    } catch (err) { console.error("Fetch error:", err); }
  };

  const handleSave = async (draft) => {
    try {
      setSaving(true);
      const res  = await fetch(API_BASE, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(draft) });
      const json = await res.json();
      if (!json.success) throw new Error(json.message);
      await fetchData();
      setModalOpen(false);
      setSaveMsg("Changes saved successfully!");
    } catch (err) {
      setSaveMsg("Save failed. Please try again.");
    } finally {
      setSaving(false);
      setTimeout(() => setSaveMsg(null), 3500);
    }
  };

  const members  = pageData.members || DEFAULT_MEMBERS;
  const featured = members.filter(m => m.featured);
  const rest     = members.filter(m => !m.featured);

  return (
    <>
      <button className="edit-fab" onClick={() => setModalOpen(true)} title="Edit management team">
        <span className="edit-fab__icon">✏️</span>
        <span className="edit-fab__label">Edit Page</span>
      </button>

      {saveMsg && <div className="editor-toast">{saveMsg}</div>}

      {modalOpen && (
        <ManagementEditModal
          data={pageData}
          onSave={handleSave}
          onClose={() => setModalOpen(false)}
          saving={saving}
        />
      )}    
      <div className="img_carriersmg">
        <img src={Avatar1} alt="" />
      </div>
   
    <section className="management-team " style={{backgroundImage: `url(${Aboutbg})`,}}>
        <div className="management-team__header">
          <h2 className="management-team__title">Management Team</h2>
          <span className="management-team__divider" />
        </div>

        {/* Featured — centered solo card */}
        <div className="management-team__featured-row">
          {featured.map((m, i) => (
            <MemberCard key={m._id || i} member={m} fallbackImg={LOCAL_IMGS[members.indexOf(m)] || Avatar} />
          ))}
        </div>

        {/* Rest — grid */}
        <div className="management-team__grid">
          {rest.map((m, i) => (
            <MemberCard key={m._id || i} member={m} fallbackImg={LOCAL_IMGS[members.indexOf(m)] || Avatar2} />
          ))}
        </div>
      </section>
    </>
  );
}